import type { SectionsFeatureComponent } from '@twisto/api-cms'

import { Media } from '../../article-components'
import { Button, DynamicContent } from '../../atoms'

import * as styles from './feature.styles'

export const Feature = ({
  text,
  cta,
  media,
  reversed,
}: SectionsFeatureComponent) => (
  <section
    css={[styles.feature, reversed ? styles.reversed : '', styles.container]}
  >
    <div css={styles.text}>
      <DynamicContent content={text} />
      <div css={styles.cta}>
        {cta?.map((button) => <Button key={button.id} {...button} />)}
      </div>
    </div>
    <div css={styles.media}>
      <Media src={media} />
    </div>
  </section>
)
